import React, { useState, useRef } from 'react';
import './App.css';
import { products } from './data/products';
import ProductCard from './components/ProductCard';
import ProductDetail from './components/ProductDetail';

function App(){
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [imageIdx, setImageIdx] = useState(0);
  const [zoomed, setZoomed] = useState(false);
  const detailRef = useRef(null);
  const isScrollLocked = useRef(false);
  const yStartRef = useRef(0);

  const handleNextProduct = () => {
    setSelectedIdx((prev) => (prev + 1) % products.length);
    setImageIdx(0);
  };

  const handlePrevProduct = () => {
    setSelectedIdx((prev) => (prev - 1 + products.length) % products.length);
    setImageIdx(0);
  };

  const handleWheel = (e) => {
    e.preventDefault();
    
    if (isScrollLocked.current) return;
    
    isScrollLocked.current = true;

    if (e.deltaY > 0) {
      handleNextProduct();
    } else if (e.deltaY < 0) {
      handlePrevProduct();
    }

    setTimeout(() => {
      isScrollLocked.current = false;
    }, 1500);
  };

  const handleTouchStart = (e) => {
    yStartRef.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    if (!yStartRef.current) return;
    
    const yEnd = e.changedTouches[0].clientY;
    const diff = yStartRef.current - yEnd;

    if (Math.abs(diff) > 50) {
      if (isScrollLocked.current) {
        yStartRef.current = 0;
        return;
      }
      
      isScrollLocked.current = true;

      if (diff > 0) {
        handleNextProduct();
      } else {
        handlePrevProduct();
      }

      setTimeout(() => {
        isScrollLocked.current = false;
      }, 1500);
    }
    
    yStartRef.current = 0;
  };

  return (
    <div className="App homepage">
      <button
        className="corner-icon corner-left"
        aria-label={zoomed ? "zoom out" : "zoom in"}
        onClick={() => setZoomed(z => !z)}
      >{zoomed ? '−' : '+'}</button>

      <nav className="main-nav" aria-label="primary">
        <ul>
          <li className="active">NEW</li>
          <li>MENS</li>
          <li>WOMENS</li>
          <li>SLIDES</li>
          <li>ACCESSORIES</li>
        </ul>
      </nav>

      <main className={"products" + (zoomed ? " zoomed" : "")} role="list">
        {products.map((p, i) => (
          <ProductCard key={i} product={p} onClick={() => setSelectedIdx(i)} />
        ))}
      </main>

      {selectedIdx !== null && (
        <ProductDetail
          product={products[selectedIdx]}
          imageIdx={imageIdx}
          onImageChange={setImageIdx}
          onClose={() => setSelectedIdx(null)}
          onNextProduct={handleNextProduct}
          onPrevProduct={handlePrevProduct}
          detailRef={detailRef}
          handleWheel={handleWheel}
          handleTouchStart={handleTouchStart}
          handleTouchEnd={handleTouchEnd}
        />
      )}
    </div>
  );
}

export default App;
